/* @flow */

export * from './config';



// WEBPACK FOOTER //
// webpack://paypal/src/config/index.js